import moment from "moment";
import classnames from "classnames";
import { toast } from "react-toastify";
import Header from "../component/Header";
import Footer from "../component/Footer";
import Details from "../component/details";
import { useLocation } from "react-router-dom";
import Pagination from "@mui/material/Pagination";

import NewLoader from "../reusedElements/NewLoader";
import { appreview, getAppConf } from "../services/paymentService";

import {
  RoundButtonDark,
  calculateParagraphHeight,
  toastobj,
  trimvalue,
} from "../commonutilities";
import React, { useEffect, useRef, useState } from "react";
import { addJournalEntry } from "../services/journaldreamService";

import ReCAPTCHA from "react-google-recaptcha";

import { TwitterShareButton, FacebookShareButton } from "react-share";
import {
  detailAgree,
  detailDisAgree,
  dreamsDetail,
  geoLocation,
  getDreamAnalysis,
  getDreamInsight,
  getInsightsConnections,
  saveFreemiumDream,
  supabaseAnalysis,
  supabaseDreamData,
  supabaseGuest,
} from "../services/sightdreamService";
import {
  Col,
  Container,
  Input,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Button,
  FormFeedback,
} from "reactstrap";
import {
  createDream,
  deletesaveddream,
  getsaveddream,
} from "../services/supabaseService";
import FooterSeventhJournal from "../component/FooterSeventhJournal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { supabase } from "..";
import HeaderSeventhJournal from "../component/HeaderSeventhJournal";
import { saveFremiumSchema } from "../ValidationSchema/Schema";
import { useFormik } from "formik";

const JournalEntry = (props) => {
  const [yesterDayChange, setYesterDayChange] = useState(false);

  return (
    <div
    /* onClick={() => {
        props.toggleMenu();
      }} */
    >
      <p className="mb-2 mt-4">
        Add a Journal entry and tell us about your day for deeper dream
        insights.
      </p>
      <Input
        type="textarea"
        className="textarea-lg mb-2 mt-2 hp-subscribe-input text-white"
        placeholder="Enter Journal"
        value={props.journaltext}
        onChange={(e) => props.setjournaltext(e.target.value)}
      />
      <Row className="mb-2">
        <Col>
          <div className="result-date-container">
            <Input
              type="date"
              className="mb-2 hp-subscribe-input text-white"
              value={props.journaldate}
              max={new Date().toISOString().split("T")[0]}
              style={{ colorScheme: "dark" }}
              onChange={(e) => {
                const selectedDate = moment(e.target.value);
                const yesterday = moment().subtract(1, "days");
                const isYesterday = selectedDate.isSame(yesterday, "day");

                props.setjournaldate(e.target.value);
                setYesterDayChange(!isYesterday);
              }}
            />
            {!yesterDayChange && (
              <span className="result-date-journal">{"(Yesterday)"}</span>
            )}
          </div>
        </Col>
        {props.screenWidth > 1400 && (
          <>
            <Col>
              <button
                className="btn btn-primary"
                onClick={() => props.addjournalentry(false)}
              >
                Add to Journal
              </button>
            </Col>
            <Col>
              <button
                className="btn btn-primary"
                onClick={() => props.addjournalentry(true)}
              >
                Resubmit Dream
              </button>
            </Col>
          </>
        )}
      </Row>
      <Row className="mb-2">
        {props.screenWidth <= 1400 && (
          <>
            <Col>
              <button
                className="btn btn-primary"
                onClick={() => props.addjournalentry(false)}
              >
                Add to Journal
              </button>
            </Col>
            <Col>
              <button
                className="btn btn-primary"
                onClick={() => props.addjournalentry(true)}
              >
                Resubmit Dream
              </button>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};
const staticMessages = {
  KeyDiscoveries: {
    text: "Discover core findings of your dream analysis, highlighting the primary massages your subconscious is communicating.",
    showButton: true,
  },
  Reflections: {
    text: "Dive deeper into your dream’s meanings with thoughtful insides and questions designed to encourage personal reflection.",
    showButton: true,
  },
  unconscious_echoes: {
    text: "Uncover the profound narrative of your subconscious through analysis of recurring dream patterns across days, weeks, months and years. Discover the long term picture!\nOne of the most beneficial aspects of dream analysis.",
    showButton: true,
  },
  spiritual_religious: {
    text: "Explore the spiritual dimensions and religious symbols within your dreams, revealing deeper layers of meaning.",
    showButton: true,
  },
  love_relationships: {
    text: "Gain insights into your emotional world through the lens of your dreams, highlighting connections and areas for growth.",
    showButton: true,
  },
  work_career: {
    text: "Decode the messages your dreams are sending about your professional life, offering clues to aspirations and anxieties.",
    showButton: true,
  },
  DreamWorldGuidance: {
    text: "Receive direct guidance based on your dreams, suggesting paths of action for personal development and decision-making.",
    showButton: true,
  },
  PracticalAdvice: {
    text: "Embark on a journey of self-healing and growth with actionable steps derived from essence of your dreams.",
    showButton: true,
  },
  TailoredTools: {
    text: "Access personalized resources designed to facilitate your personal transformation and growth journey.",
    showButton: false,
  },
  RecommendedVideos: {
    text: "Watch curated videos that resonate with the themes of your dreams.",
    showButton: true,
  },
  RelatedBlogs: {
    text: "Read engaging blogs and articles that address the issues and themes revealed by your dream analysis.",
    showButton: false,
  },
  RecommendedBooks: {
    text: "Dive into a selection of books tailored to help you navigate and overcome the challenges identified in your dreams.",
    showButton: false,
  },
  RecommendedPodcasts: {
    text: "Listen to podcasts that complement your growth journey, carefully selected based on your dream analysis result.",
    showButton: true,
  },
  Details: {
    text: "Discover core findings of your dream analysis, highlighting the primary massages your subconscious is communicating.",
    showButton: true,
  },
};

const FreemiumComponent = (props) => {
  const message = staticMessages[props.keyobject];

  const paragraphs = message?.text
    .split("\n")
    .map((paragraph, index) => <p key={index}>{paragraph}</p>);

  return (
    <div className="freemium_glass_eff">
      {paragraphs}
      {message.showButton && (
        <button
          className="acct-btn-guest"
          onClick={() => {
            props.setsignupmodalhome(true);
          }}
        >
          Create an Account for free to Unlock
        </button>
      )}
    </div>
  );
};
const Result = (args) => {
  const { state } = useLocation();
  let analysisContentRef = useRef();
  let freemiumCaptcha = useRef();
  const messagesEndRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [toggleShare, settoggleShare] = useState(false);
  const [footernum, setfooternum] = useState("");
  const [journaltext, setjournaltext] = useState("");
  const [footeremail, setfooteremail] = useState("");
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [journaldate, setjournaldate] = useState(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );

  //bkpdata usestate
  const [bkpadvice, setbkpadvice] = useState({});
  const [bkpdetail, setbkpdetail] = useState({});
  const [bkpinsight, setbkpinsight] = useState({});
  const [bkpanalysis, setbkpanalysis] = useState({});
  const [currentadviceholder, setcurrentadviceholder] = useState({});
  const [currentinsightholder, setcurrentinsightholder] = useState({});

  //saveddream usestate
  const [pageno, setpageno] = useState(1);
  const [getpageno, setgetpageno] = useState();
  const [currentdream, setcurrentdream] = useState({});
  const [savedreamsleep, setsavedreamsleep] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [feedbackmodal, setfeedbackmodal] = useState(false);
  const [email, setemail] = useState("");
  const [review, setreview] = useState("");
  const [username, setusername] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [width, setWidth] = useState();
  const [shouldShowPrompt, setShouldShowPrompt] = useState(true);
  const [expandedState, setExpandedState] = useState({});
  const [insightsConnections, setInsightsConnections] = useState(null);
  const [reload, setReload] = useState(false);
  const [tempDreamId, setTempDreamId] = useState([]);
  const boldRegex = /(\*\*.+?\*\*)/g;
  const [fremiumData, setFremiumData] = useState(false);

  const [capthcaValidity, setCaptchaValidity] = useState(null);
  const [showmoreInsights, setshowmoreInsights] = useState({
    Connections: false,
    unconscious_echoes: false,
    spiritual_religious: false,
    love_relationships: false,
    work_career: false,
  });
  const [signupmodalhome, setsignupmodalhome] = useState(false);
  const {
    values,
    errors,
    handleChange,
    handleSubmit: handleFreemiumSubmit,
    handleBlur,
    touched,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      email: "",
      recaptcha: "",
    },
    validationSchema: saveFremiumSchema,
    onSubmit: (values, action) => {
      // Handle your form submission here
      // console.log(values);
      // action.resetForm();
      handleFreeSubmit(values);
    },
  });
  const getheight = (val, data) => {
    if (showmoreInsights[val] || calculateParagraphHeight(data) < 75) {
      return "100%";
    } else {
      return "75px";
    }
  };
  const handleshowmore = (val) => {
    let obj = { ...showmoreInsights };
    obj[val] = !obj[val];
    setshowmoreInsights(obj);
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  /* useEffect(() => {
    const unloadCallback = (event) => {
      const e = event || window.event;
      //console.log(e)
      e.preventDefault();
      if (e) {
        e.returnValue = "";
      }
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      //cleanup function
      window.removeEventListener("beforeunload", unloadCallback);
    };
  }, []); */

  useEffect(() => {
    const getfooterdetail = () => {
      getAppConf("footer_email").then((res) => {
        if (res.data.status) setfooteremail(res.data.value);
      });
      getAppConf("footer_number").then((res) => {
        if (res.data.status) setfooternum(res.data.value);
      });
    };
    getfooterdetail();
  }, []);

  useEffect(() => {
    scrollToBottom();
    if (state.dreamDataId || state.guest) {
      let obj = { ...state };
      setcurrentdream(obj);
      let freemium = JSON.parse(sessionStorage.getItem("SeventhSightFreemium"));
      // console.log(freemium);
      if (freemium && freemium?.dream) {
        setFremiumData(true);
      }
      if (!state.guest) {
        getsaveddream(state.email).then((res) => {
          if (res.error === null) {
            let data = JSON.parse(JSON.stringify(res.data));
            data.unshift(obj);
            setsavedreamsleep(data);
            setgetpageno(data.length);
            let temp = JSON.parse(
              localStorage.getItem("SeventhSightDreamAnalysis")
            );
            if (res.data.length == 0 && temp.length >= 1) {
              setsavedreamsleep(temp);
              setgetpageno(temp.length);
              setReload(true);
            }
          }
        });
      }
      setbkpanalysis({ [state.dreamDataId]: {} });
      setbkpdetail({ [state.dreamDataId]: [] });
      setbkpadvice({ [state.dreamDataId]: {} });
      setbkpinsight({ [state.dreamDataId]: {} });
      handleanalysis(state, 0, state.guest);
    }
  }, [state]);

  useEffect(() => {
    if (currentinsightholder["data"]) {
      let obj = { [currentinsightholder["id"]]: currentinsightholder["data"] };
      setbkpinsight((bkpinsight) => {
        return { ...bkpinsight, ...obj };
      });
    }
    let freemium = JSON.parse(sessionStorage.getItem("SeventhSightFreemium"));
    if (freemium && freemium?.dream && state?.guest) {
      setFremiumData(true);
    }
  }, [currentinsightholder]);

  useEffect(() => {
    if (currentadviceholder["data"]) {
      let obj = { [currentadviceholder["id"]]: currentadviceholder["data"] };
      setbkpadvice((bkpadvice) => {
        return { ...bkpadvice, ...obj };
      });
    }
  }, [currentadviceholder]);

  const handleanalysis = (obj, index, guest = false) => {
    let localObj = JSON.parse(
      localStorage.getItem("SeventhSightDreamAnalysis")
    );
    if (localObj && localObj[index].dreamDataId) {
      supabaseDreamData(localObj[index].dreamDataId).then((res) => {
        if (res.error === null) {
          let data = res.data[0];
          let tempObj = {
            insights: true,
            advice: true,
            dream_details: true,
          };

          if (data?.analysis) {
            setLoading(false);
            const obj2 = { ...bkpanalysis };
            obj2[obj["dreamDataId"]] = JSON.parse(data?.analysis);
            setbkpanalysis(obj2);
            const handleData = (type, state, key) => {
              if (data[type]) {
                tempObj[key] = false;
                state({
                  data: JSON.parse(data[type]),
                  id: localObj[index].dreamDataId,
                });
              } else {
                state({ [localObj[index].dreamDataId]: {} });
              }
            };

            handleData("insights", setcurrentinsightholder, "insights");
            handleData("advice", setcurrentadviceholder, "advice");

            if (localObj[index]?.dream_details) {
              tempObj["dream_details"] = false;
              setbkpdetail(localObj[0]?.dream_details);
            }
            if (!tempDreamId.includes(localObj[index].dreamDataId)) {
              tempDreamId.push(localObj[index].dreamDataId);
              handleDetail(obj, guest, tempObj, index);
            }
          } else {
            getDreamAnalysisData(obj, guest, tempObj);
          }
        }
      });
    } else {
      getDreamAnalysisData(obj, guest);
    }
  };
  const getDreamAnalysisData = (obj, guest, tempObj) => {
    handleDetail(obj, guest, tempObj, 0);
    let obj2 = { ...bkpanalysis };
    getDreamAnalysis(obj, guest)
      .then((res) => {
        if (res.status === 200) {
          let body = {};
          if (guest) {
            body["analysis"] = res.data;
            if (!obj?.freemium) {
              supabaseGuest(body, obj.dreamDataId);
            } else {
              let data = {
                analysis: res.data,
                chatbot_id: state?.chatid || null,
                dream: state?.dream,
              };
              sessionStorage.setItem(
                "SeventhSightFreemium",
                JSON.stringify(data)
              );
            }
          } else {
            body["analysis"] = JSON.stringify(res.data);
            // console.log(body['analysis']);
            supabaseAnalysis(body, obj.dreamDataId, state?.user_id);
          }
          obj2[obj["dreamDataId"]] = res.data;
        } else {
          toast.error("No Data Available");
          obj2[obj["dreamDataId"]] = {};
        }
        setbkpanalysis(obj2);
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.data?.status_code === 401) {
          deleteDream(obj["dreamDataId"]);
        }
        toast.error(
          err?.response?.data?.error || "Something went Wrong",
          toastobj
        );
        obj2[obj["dreamDataId"]] = {};
        setbkpanalysis(obj2);
        setLoading(false);
      });
  };
  const deleteDream = async (selectedId) => {
    const { data, error } = await supabase
      .from("DreamsData")
      .delete()
      .eq("id", selectedId);
  };

  useEffect(() => {
    let page = pageno - 1;
    let data = JSON.parse(JSON.stringify(savedreamsleep));

    let obj = { ...data[page] };
    data.splice(page, 1);

    if (obj["dreamDataId"]) {
      let temp = JSON.parse(localStorage.getItem("SeventhSightDreamAnalysis"));
      setcurrentdream(obj);
      const index = temp.findIndex(
        (item) => item.dreamDataId === obj["dreamDataId"]
      );
      if (reload && index != -1) {
        handleanalysis(obj, index);
      }
    } else {
      if (obj["email"]) {
        setLoading(true);
        createDream(obj).then((res) => {
          if (res.error === null) {
            obj["dreamDataId"] = res.data[0].id;
            obj["seventhjournal"] = state.seventhjournal;
            obj["token"] = state.token;
            setcurrentdream(obj);
            let dreamobj = { [res.data[0].id]: {} };
            let dreamobj2 = { [res.data[0].id]: [] };
            setbkpanalysis({ ...bkpanalysis, ...dreamobj });
            setbkpdetail({ ...bkpdetail, ...dreamobj2 });
            setbkpadvice({ ...bkpadvice, ...dreamobj });
            setbkpinsight({ ...bkpinsight, ...dreamobj });
            data.splice(page, 0, obj);
            const existingArray =
              JSON.parse(localStorage.getItem("SeventhSightDreamAnalysis")) ||
              [];
            const index = existingArray.length;

            if (index !== -1) {
              existingArray.push(obj);
              localStorage.setItem(
                "SeventhSightDreamAnalysis",
                JSON.stringify(existingArray)
              );
              handleanalysis(obj, index);
              setsavedreamsleep(data);
            }
          }
        });
        deletesaveddream(obj["id"]);
      }
    }
  }, [pageno]);

  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    scrollToBottom();
  };

  const handleDetail = async (obj, guest = false, tempObj, index) => {
    await dreamsDetail(
      obj,
      setbkpdetail,
      setcurrentinsightholder,
      setcurrentadviceholder,
      guest,
      tempObj,
      index
    );
  };

  const handleagree = async (index) => {
    if (state?.guest) {
      toast.error("Please Login to continue", toastobj);
      return;
    }
    if (
      bkpdetail?.[currentdream["dreamDataId"]]?.[index]?.["status"] === "agree"
    )
      return;
    let data = JSON.parse(
      JSON.stringify(bkpdetail?.[currentdream["dreamDataId"]])
    );
    data[index]["status"] = "agree";
    let obj56 = { [currentdream["dreamDataId"]]: data };
    setbkpdetail({ ...bkpdetail, ...obj56 });
    detailAgree(bkpdetail?.[currentdream["dreamDataId"]]?.[index]["id"]);
  };
  const handledisagree = (index) => {
    if (state?.guest) {
      toast.error("Please Login to continue", toastobj);
      return;
    }
    detailDisAgree(
      bkpdetail?.[currentdream["dreamDataId"]],
      setbkpdetail,
      index,
      currentdream?.dreamDataId,
      state?.email,
      bkpdetail
    );
  };

  const openlink = (link) => {
    window.open(link, "_blank");
  };

  const addjournalentry = (flag = false) => {
    if (!journaltext) {
      toast.error("Error! Please fill above fields", toastobj);
      return;
    }
    setLoading(true);
    let date;
    if (journaldate === moment().format("YYYY-MM-DD")) {
      date = moment().format("YYYY-MM-DD hh:mm:ss");
    } else {
      if (journaldate) date = moment(journaldate).format("YYYY-MM-DD hh:mm:ss");
    }
    let formdata = new FormData();
    formdata.append("journal_entry", `<p>${journaltext}</p>`);
    formdata.append("gratitude_entry", "");
    formdata.append("timestamp", date);
    formdata.append("emotion", state.emotion);
    formdata.append("email", state.email);
    formdata.append("user_id", state.user_id);
    geoLocation()
      .then((jres) => {
        if (jres.status === 200) {
          formdata.append("latitude", jres.data.latitude.toString());
          formdata.append("longitude", jres.data.longitude.toString());
          insertjournal(formdata, flag);
        } else {
          formdata.append("latitude", "0");
          formdata.append("longitude", "0");
          insertjournal(formdata, flag);
        }
      })
      .catch((err) => {
        formdata.append("latitude", "0");
        formdata.append("longitude", "0");
        insertjournal(formdata, flag);
      });
  };

  const insertjournal = (formdata, flag) => {
    addJournalEntry(formdata, state.token)
      .then((res) => {
        if (res.status === 200) {
          setjournaltext("");
          if (flag) {
            getDreamInsight(
              bkpdetail[currentdream["dreamDataId"]],
              currentdream,
              setcurrentinsightholder,
              state.guest,
              setLoading
            );
            getInsightsConnections(
              bkpdetail[currentdream["dreamDataId"]],
              currentdream,
              setInsightsConnections,
              state.guest,
              setLoading
            );
          } else {
            setLoading(false);
            toast.success(
              "Success! Journal entry added successfully",
              toastobj
            );
          }
        } else {
          toast.error(
            "Error! Something went wrong while entering detail",
            toastobj
          );
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.error) {
          toast.error(`Error! ${err?.response?.data?.error}`, toastobj);
        } else {
          toast.error(`Error! Something Went Wrong`, toastobj);
        }
        setLoading(false);
      });
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };
  const togglefeedback = () => {
    setfeedbackmodal(!feedbackmodal);
    setusername("");
    setemail("");
    setreview("");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !username || !review) {
      toast.error("Please enter details to continue", toastobj);
      return;
    }
    if (!capthcaValidity) {
      toast.error("Please Verify Captcha", toastobj);
      return;
    }
    toast.success(`Success!! Review Sent Successfully`, toastobj);
    togglefeedback();
    let body = {
      review,
      user_name: username,
      user_email: email,
    };
    let href = window.location.href;
    if (href.split("seventharc").length > 1) {
      body["site"] = "SeventhArc";
    } else if (href.split("seventhjournal").length > 1) {
      body["site"] = "SeventhJournal";
    } else {
      body["site"] = "SeventhSight";
    }
    setCaptchaValidity(null);
    appreview(body);
  };
  useEffect(() => {
    const contentElement = document.getElementById("new-analysis-content");
    // console.log(contentElement);

    if (contentElement && contentElement.scrollHeight > 4 * 16) {
      setShowMoreBtn(true); // 1em = 16px (adjust as needed)
    } else {
      setShowMoreBtn(false);
    }
  }, [savedreamsleep[pageno - 1]?.dream]);
  useEffect(() => {
    if (state?.guest?.dream) {
      const contentElement = document.getElementById("new-analysis-content");
      // console.log(contentElement);

      if (contentElement && contentElement.scrollHeight > 4 * 16) {
        setShowMoreBtn(true); // 1em = 16px (adjust as needed)
      } else {
        setShowMoreBtn(false);
      }
    }
  }, [state?.guest]);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, [window.innerWidth]);

  const unloadCallback = (event) => {
    if (shouldShowPrompt) {
      const confirmationMessage = "Are you sure you want to leave?";
      event.preventDefault();
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    }
  };

  useEffect(() => {
    const areObjectsNonEmpty =
      Object.keys(bkpadvice?.[currentdream["dreamDataId"]] || {}).length > 0 &&
      Object.keys(bkpanalysis?.[currentdream["dreamDataId"]] || {}).length >
        0 &&
      Object.keys(bkpinsight?.[currentdream["dreamDataId"]] || {}).length > 0;

    if (areObjectsNonEmpty) {
      setShouldShowPrompt(false);
      window.removeEventListener("beforeunload", unloadCallback);
      // console.log("......504");
    } else {
      window.addEventListener("beforeunload", unloadCallback);
    }

    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
    };
  }, [bkpadvice, bkpanalysis, bkpinsight]);

  const toggleExpand = (dataKey) => {
    setExpandedState((prevExpandedState) => ({
      ...prevExpandedState,
      [dataKey]: !prevExpandedState[dataKey],
    }));
  };

  const renderParagraphs = (
    dataKey,
    subDataKey,
    relevancePercentage,
    title,
    freemium
  ) => {
    const isExpanded = freemium ? true : expandedState[dataKey];

    if (insightsConnections?.data?.Connections && dataKey == "Connections") {
      return (
        <>
          <div
            key={dataKey}
            className="pointer"
            onClick={() => toggleExpand(dataKey)}
          >
            <div className="accordion-header flexRowStart w-100 jc-spb al-center mb-1">
              <h3 className="mb-2 pointer">
                {title}
                {relevancePercentage ? (
                  <>
                    {"   "}
                    <span className="textPrimary">
                      {
                        bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                          relevancePercentage
                        ]
                      }
                    </span>
                    {"   "}
                    Relevant
                  </>
                ) : null}{" "}
              </h3>
              {!freemium && isExpanded ? (
                <FontAwesomeIcon icon={faChevronUp} className="pointer" />
              ) : (
                <FontAwesomeIcon icon={faChevronDown} className="pointer" />
              )}
            </div>
            {isExpanded && (
              <div
                style={{
                  height: getheight(
                    dataKey,
                    insightsConnections && dataKey === "Connections"
                      ? insightsConnections.data.Connections
                      : subDataKey
                      ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                          subDataKey
                        ]
                      : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
                  ),
                  overflow: "hidden",
                }}
              >
                <p>
                  {trimvalue(
                    insightsConnections && dataKey === "Connections"
                      ? insightsConnections.data.Connections
                      : subDataKey
                      ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                          subDataKey
                        ]
                      : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
                  ).map((item, index) => (
                    <p key={index} className="mt-2 capitalfirstword">
                      {item}
                    </p>
                  ))}
                </p>
              </div>
            )}
          </div>
          {isExpanded &&
            calculateParagraphHeight(
              insightsConnections && dataKey === "Connections"
                ? insightsConnections.data.Connections
                : subDataKey
                ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                    subDataKey
                  ]
                : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
            ) > 75 && (
              <span
                className="analysis-content-span mb-2"
                onClick={() => handleshowmore(dataKey)}
              >
                {showmoreInsights[dataKey] ? "Show Less" : "Show More"}
              </span>
            )}
        </>
      );
    } else if (dataKey !== "Connections") {
      return (
        <>
          <div
            key={dataKey}
            className="pointer"
            onClick={() => toggleExpand(dataKey)}
          >
            <div className="accordion-header flexRowStart w-100 jc-spb al-center mb-1">
              <h3 className="mb-2 pointer">
                {title}
                {relevancePercentage ? (
                  <>
                    {"   "}
                    <span className="textPrimary">
                      {
                        bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                          relevancePercentage
                        ]
                      }
                    </span>
                    {"   "}
                    Relevant
                  </>
                ) : null}{" "}
              </h3>
              {!freemium ? (
                isExpanded ? (
                  <FontAwesomeIcon icon={faChevronUp} className="pointer" />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} className="pointer" />
                )
              ) : null}
            </div>
            {!freemium ? (
              isExpanded && (
                <div
                  style={{
                    height: getheight(
                      dataKey,
                      subDataKey
                        ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                            subDataKey
                          ]
                        : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
                    ),
                    overflow: "hidden",
                  }}
                >
                  <p>
                    {trimvalue(
                      subDataKey
                        ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                            subDataKey
                          ]
                        : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
                    ).map((item, index) => (
                      <p key={index} className="mt-2 capitalfirstword">
                        {item}
                      </p>
                    ))}
                  </p>
                </div>
              )
            ) : (
              <div style={freemium ? { position: "relative" } : {}}>
                {freemium && (
                  <FreemiumComponent
                    keyobject={dataKey}
                    setsignupmodalhome={setsignupmodalhome}
                  />
                )}
                <p>
                  {trimvalue(
                    subDataKey
                      ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                          subDataKey
                        ]
                      : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
                  ).map((item, index) => (
                    <p key={index} className="mt-2 capitalfirstword">
                      {item}
                    </p>
                  ))}
                </p>
              </div>
            )}
          </div>
          {isExpanded &&
            calculateParagraphHeight(
              subDataKey
                ? bkpinsight?.[currentdream.dreamDataId]?.[dataKey]?.[
                    subDataKey
                  ]
                : bkpinsight?.[currentdream.dreamDataId]?.[dataKey]
            ) > 75 && (
              <>
                {!freemium ? (
                  <span
                    className="analysis-content-span mb-2"
                    onClick={() => handleshowmore(dataKey)}
                  >
                    {showmoreInsights[dataKey] ? "Show Less" : "Show More"}
                  </span>
                ) : null}
              </>
            )}
        </>
      );
    } else {
      return null;
    }
  };
  const handleFreeSubmit = async (values) => {
    // console.log(values);

    const { data: veruser } = await supabase
      .from("users")
      .select()
      .eq("email", values.email.toLowerCase());

    if (veruser.length > 0) {
      toast.error(
        "Oops! User Already Exist. Please login to continue...",
        toastobj
      );
      return;
    }
    let freemium = JSON.parse(sessionStorage.getItem("SeventhSightFreemium"));
    if (freemium && freemium?.dream) {
      let freemiumData = {
        analysis: freemium?.analysis,
        chatbot_data_id: freemium?.chatbot_id,
        email: values.email.toLowerCase(),
        journalDate: new Date().toISOString(),
        dream: freemium?.dream,
        image: freemium?.image,
      };
      // console.log(freemiumData);
      saveFreemiumDream(freemiumData)
        .then((res) => {
          if (res?.data?.success) {
            setFremiumData(false);
            sessionStorage.removeItem("SeventhSightFreemium");
            resetForm();
          }
          /* if(res?.data?.status){
          toast.success("")
        } */
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  return (
    <div>
      {loading && <NewLoader />}
      <Header
        togglefeedback={togglefeedback}
        toggleMenu={showMenu}
        subType={args.subType}
        signupmodalhome={signupmodalhome}
        setsignupmodalhome={setsignupmodalhome}
        captchaKey={args.captchaKey}
        noFreeCredit={args.noFreeCredit}
      />
      <div ref={messagesEndRef} />
      {/* Main Body  */}
      <div
        className="hero-result"
        onClick={() => {
          toggleMenu();
        }}
      >
        <Container>
          <Row>
            <Col
              md="5"
              onClick={() => {
                args.toggleMenu();
              }}
            >
              <h2>
                <span>DREAM RESULTS </span>
              </h2>

              {savedreamsleep.length > 0 && (
                <>
                  <div className="analysis-content-leftbox new-analysis-content-leftbox">
                    <div
                      id="new-analysis-content"
                      className={
                        showMore
                          ? "analysis-content-expanded"
                          : "analysis-content-collapsed"
                      }
                    >
                      {savedreamsleep[pageno - 1]?.dream}
                    </div>
                  </div>
                  {showMoreBtn && (
                    <span
                      className="analysis-content-span"
                      onClick={toggleShowMore}
                    >
                      {showMore ? "Show Less" : "Show More"}
                    </span>
                  )}

                  {savedreamsleep.length > 1 && (
                    <div className="pdream_pagination">
                      <div
                        className="flexCenter w-100 cg-1"
                        style={{ marginTop: "1rem" }}
                      >
                        <RoundButtonDark
                          type={"backward"}
                          filled={false}
                          onClick={() => {
                            if (pageno - 1 > 0) {
                              setpageno(pageno - 1);

                              toggle("1");
                            }
                          }}
                        />
                        <span>
                          {bkpanalysis?.[
                            currentdream["dreamDataId"]
                          ]?.title?.substring(0, 30)}
                        </span>
                        <RoundButtonDark
                          type={"forward"}
                          filled={false}
                          onClick={() => {
                            if (pageno + 1 <= getpageno) {
                              setpageno(pageno + 1);

                              toggle("1");
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              {state.guest && (
                <>
                  <div className="analysis-content-leftbox new-analysis-content-leftbox">
                    <div
                      id="new-analysis-content"
                      className={
                        showMore
                          ? "analysis-content-expanded"
                          : "analysis-content-collapsed"
                      }
                    >
                      {state?.dream}
                    </div>
                  </div>
                  {showMoreBtn && (
                    <span
                      className="analysis-content-span"
                      onClick={toggleShowMore}
                    >
                      {showMore ? "Show Less" : "Show More"}
                    </span>
                  )}
                </>
              )}
            </Col>
            <Col md="7">
              <div
                className="analysis-content"
                ref={analysisContentRef}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Container>
                  <Row>
                    <Col>
                      <h3 className="mt-4">
                        {bkpanalysis?.[currentdream["dreamDataId"]]?.title}
                      </h3>
                      <Row className="paddingbottom50 results-tabs">
                        <Col>
                          <Nav tabs className="mb-5 justify-content-start">
                            <NavItem className="pointer">
                              <NavLink
                                className={classnames({
                                  active: currentActiveTab === "1",
                                })}
                                onClick={() => toggle("1")}
                              >
                                Analysis
                              </NavLink>
                            </NavItem>
                            <NavItem className="pointer">
                              <NavLink
                                className={classnames({
                                  active: currentActiveTab === "2",
                                })}
                                onClick={() => {
                                  if (
                                    bkpinsight?.[currentdream["dreamDataId"]] &&
                                    Object.keys(
                                      bkpinsight?.[currentdream["dreamDataId"]]
                                    )?.length !== 0
                                  ) {
                                    toggle("2");
                                  }
                                }}
                              >
                                {bkpinsight?.[currentdream["dreamDataId"]] &&
                                Object.keys(
                                  bkpinsight?.[currentdream["dreamDataId"]]
                                )?.length === 0 ? (
                                  <div className="flexRowStart al-center">
                                    Insights
                                    <div
                                      className="new-spinner"
                                      id="new-spinner"
                                    ></div>
                                  </div>
                                ) : (
                                  "Insights"
                                )}
                              </NavLink>
                            </NavItem>
                            <NavItem className="pointer">
                              <NavLink
                                className={classnames({
                                  active: currentActiveTab === "3",
                                })}
                                onClick={() => {
                                  if (
                                    bkpadvice?.[currentdream["dreamDataId"]] &&
                                    Object.keys(
                                      bkpadvice?.[currentdream["dreamDataId"]]
                                    )?.length !== 0
                                  )
                                    toggle("3");
                                }}
                              >
                                {bkpadvice?.[currentdream["dreamDataId"]] &&
                                Object.keys(
                                  bkpadvice?.[currentdream["dreamDataId"]]
                                )?.length === 0 ? (
                                  <div className="flexRowStart al-center">
                                    Advice
                                    <div
                                      className="new-spinner"
                                      id="new-spinner"
                                    ></div>
                                  </div>
                                ) : (
                                  "Advice"
                                )}
                              </NavLink>
                            </NavItem>
                            <NavItem className="pointer">
                              <NavLink
                                className={classnames({
                                  active: currentActiveTab === "4",
                                })}
                                onClick={() => toggle("4")}
                              >
                                Details
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent activeTab={currentActiveTab}>
                            <TabPane tabId="1">
                              <Row>
                                <Col>
                                  <div>
                                    {!loading &&
                                    !bkpanalysis?.[
                                      currentdream["dreamDataId"]
                                    ]?.["analysis"] ? (
                                      <p className="mt-2 text-danger">
                                        No Data Available
                                      </p>
                                    ) : (
                                      <div>
                                        {trimvalue(
                                          bkpanalysis?.[
                                            currentdream["dreamDataId"]
                                          ]?.["analysis"]
                                        ).map((item, index) => (
                                          <p
                                            key={index}
                                            className="mt-2 capitalfirstword"
                                          >
                                            {item
                                              .split(boldRegex)
                                              .map((part, idx) =>
                                                boldRegex.test(part) ? (
                                                  <h3
                                                    key={idx}
                                                    style={{
                                                      marginBottom: "0px",
                                                    }}
                                                  >
                                                    {part.replace(/\*\*/g, "")}
                                                  </h3>
                                                ) : (
                                                  <span key={idx}>{part}</span>
                                                )
                                              )}
                                          </p>
                                        ))}
                                        {bkpanalysis?.[
                                          currentdream["dreamDataId"]
                                        ]?.["analysis"] &&
                                          state?.guest &&
                                          state?.freemium && (
                                            <div className="beta-tester-details-cont">
                                              <h3
                                                style={{
                                                  fontStyle: "normal",
                                                }}
                                              >
                                                For a deeper understanding of
                                                what your subconscious is
                                                communicating consider exploring
                                                our premium features which
                                                include:
                                              </h3>
                                              <ul>
                                                <li>
                                                  Personalized Symbol
                                                  Interpretations.
                                                </li>
                                                <li>
                                                  Integration with your daily
                                                  JOURNAL for deeper insights.
                                                </li>
                                                <li>
                                                  Integration with your ARC
                                                  personality test.
                                                </li>
                                                <li>
                                                  Unlimited dream analysis.
                                                </li>
                                                <li>
                                                  Extensive symbolgy, over
                                                  30,000 symbols.
                                                </li>
                                                <li>
                                                  Long-term patterns (A dream is
                                                  a powerful image, multiple
                                                  dreams make a movie)
                                                </li>
                                                <li>
                                                  Custom Advice, videos and
                                                  resources on navigating your
                                                  emotional landscape.
                                                </li>
                                              </ul>
                                            </div>
                                          )}
                                        {bkpanalysis?.[
                                          currentdream["dreamDataId"]
                                        ]?.["analysis"] &&
                                          state?.guest &&
                                          state?.freemium &&
                                          bkpinsight?.[
                                            currentdream["dreamDataId"]
                                          ] &&
                                          Object.keys(
                                            bkpinsight?.[
                                              currentdream["dreamDataId"]
                                            ]
                                          )?.length > 0 && (
                                            <div>
                                              {fremiumData ? (
                                                <div>
                                                  <h3 className="mt-2">
                                                    Add your email to save this
                                                    dream for long-term patterns
                                                  </h3>
                                                  <FormGroup className="position-relative">
                                                    <Input
                                                      name="email"
                                                      placeholder="Email"
                                                      type="email"
                                                      value={values.email}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      valid={
                                                        touched.email &&
                                                        !errors.email
                                                      }
                                                      invalid={
                                                        touched.email &&
                                                        !!errors.email
                                                      }
                                                      style={{
                                                        background:
                                                          "rgba(255, 255, 255, 0.05)",
                                                        color: "white",
                                                      }}
                                                    />

                                                    {touched.email ? (
                                                      <FormFeedback>
                                                        {errors.email}
                                                      </FormFeedback>
                                                    ) : null}
                                                  </FormGroup>
                                                  <div
                                                    className={`${
                                                      window.innerWidth > 720
                                                        ? "flexRowStart al-center"
                                                        : "flexColStart"
                                                    } w-100`}
                                                  >
                                                    <FormGroup className="position-relative">
                                                      {args.captchaKey && (
                                                        <>
                                                          <Label>Captcha</Label>
                                                          <ReCAPTCHA
                                                            name="recaptcha"
                                                            ref={
                                                              freemiumCaptcha
                                                            }
                                                            sitekey={
                                                              args.captchaKey
                                                            }
                                                            /* sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                                            render="explicit" */
                                                            theme="dark"
                                                            onChange={(e) => {
                                                              // console.log(e);
                                                              setFieldValue(
                                                                "recaptcha",
                                                                e
                                                              );
                                                            }}
                                                          />
                                                        </>
                                                      )}
                                                      {touched.recaptcha &&
                                                      errors.recaptcha ? (
                                                        <div className="text-danger">
                                                          {errors.recaptcha}
                                                        </div>
                                                      ) : null}
                                                    </FormGroup>

                                                    <Button
                                                      className="w-100 btn-primary mt-0"
                                                      onClick={
                                                        handleFreemiumSubmit
                                                      }
                                                    >
                                                      Submit
                                                    </Button>
                                                  </div>
                                                </div>
                                              ) : (
                                                <h3 className="mb-2 textPrimary">
                                                  Thank you! Eventually you
                                                  might want to create an
                                                  account and this ensures your
                                                  dream analysis is saved to
                                                  that email for any important
                                                  long-term patterns. You can
                                                  create a{" "}
                                                  <span
                                                    className="pointer"
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      color: "#7447f7",
                                                    }}
                                                    onClick={() =>
                                                      setsignupmodalhome(true)
                                                    }
                                                  >
                                                    Free Account
                                                  </span>{" "}
                                                  at any time
                                                </h3>
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="2">
                              <Row>
                                <Col>
                                  {/* {bkpinsight?.[currentdream["dreamDataId"]]
                                    ?.loader ? (
                                    <p className="mt-2 text-danger">
                                      <strong>
                                        Please Wait! We are loading data..
                                      </strong>
                                    </p>
                                  ) : ( */}
                                  {bkpinsight?.[
                                    currentdream["dreamDataId"]
                                  ] && (
                                    <>
                                      {bkpinsight?.[currentdream["dreamDataId"]]
                                        ?.error ? (
                                        <p className="mt-2 text-danger">
                                          <strong>No Data Available</strong>
                                        </p>
                                      ) : (
                                        <>
                                          {Object.keys(
                                            bkpinsight?.[
                                              currentdream["dreamDataId"]
                                            ]
                                          ).length === 0 ? (
                                            <p className="mt-2 text-danger">
                                              <strong>
                                                Please wait, we are analyzing
                                                your results...
                                              </strong>
                                            </p>
                                          ) : (
                                            <div>
                                              <h3 className="mb-2">
                                                Key Discoveries
                                              </h3>
                                              <div
                                                style={{ position: "relative" }}
                                              >
                                                {state?.guest &&
                                                  state?.freemium && (
                                                    <FreemiumComponent
                                                      keyobject={
                                                        "KeyDiscoveries"
                                                      }
                                                      setsignupmodalhome={
                                                        setsignupmodalhome
                                                      }
                                                    />
                                                  )}
                                                {trimvalue(
                                                  bkpinsight?.[
                                                    currentdream["dreamDataId"]
                                                  ]?.["key_discoveries"]
                                                ).map((item, index) => (
                                                  <p
                                                    key={index}
                                                    className="mt-2 capitalfirstword"
                                                  >
                                                    {item}
                                                  </p>
                                                ))}
                                              </div>
                                              <div className="visual-tab-item">
                                                {bkpinsight?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["image"] && (
                                                  <img
                                                    src={
                                                      bkpinsight?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.["image"]
                                                    }
                                                    alt="insight_image"
                                                    className="mb-2"
                                                    style={{
                                                      width: "100%",
                                                    }}
                                                  />
                                                )}
                                                <div className="visual-tab-item-share">
                                                  <div>
                                                    <img
                                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/visual-share-icon1.png?t=2024-01-10T08%3A27%3A13.358Z"
                                                      alt=""
                                                      onClick={() =>
                                                        settoggleShare(
                                                          !toggleShare
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  {toggleShare && (
                                                    <div className="d-flex flex-column">
                                                      <FacebookShareButton
                                                        url={`https://db.seventhsight.com/storage/v1/object/public/Visual_image/${
                                                          bkpinsight?.[
                                                            currentdream[
                                                              "dreamDataId"
                                                            ]
                                                          ]?.["image_supabase"]
                                                        }`}
                                                      >
                                                        <img
                                                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/visual-share-icon3.png"
                                                          alt="Facebook"
                                                        />
                                                      </FacebookShareButton>
                                                      {/* <img
                                                          src={
                                                            ShareButtonInstagram
                                                          }
                                                          alt=""
                                                        /> */}
                                                      <TwitterShareButton
                                                        url={`https://db.seventhsight.com/storage/v1/object/public/Visual_image/${
                                                          bkpinsight?.[
                                                            currentdream[
                                                              "dreamDataId"
                                                            ]
                                                          ]?.["image_supabase"]
                                                        }`}
                                                      >
                                                        <img
                                                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/visual-share-icon4.png?t=2024-01-10T08%3A30%3A48.803Z"
                                                          alt="Twitter"
                                                        />
                                                      </TwitterShareButton>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              <h3 className="mb-2">
                                                Reflections
                                              </h3>
                                              <div
                                                style={{ position: "relative" }}
                                              >
                                                {state?.guest &&
                                                  state?.freemium && (
                                                    <FreemiumComponent
                                                      keyobject={"Reflections"}
                                                      setsignupmodalhome={
                                                        setsignupmodalhome
                                                      }
                                                    />
                                                  )}
                                                {trimvalue(
                                                  bkpinsight?.[
                                                    currentdream["dreamDataId"]
                                                  ]?.["reflections"]
                                                ).map((item, index) => (
                                                  <p
                                                    key={index}
                                                    className="mt-2 capitalfirstword"
                                                  >
                                                    {item}
                                                  </p>
                                                ))}
                                                <div>
                                                  <h5
                                                    className="mb-2"
                                                    style={{
                                                      fontStyle: "italic",
                                                    }}
                                                  >
                                                    {
                                                      bkpinsight?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.["key_summary"]
                                                    }
                                                  </h5>
                                                </div>
                                              </div>
                                              {!state.guest && (
                                                <>
                                                  {!state.seventhjournal ? (
                                                    <div className="my-4">
                                                      {bkpinsight?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.[
                                                        "first_free_entry"
                                                      ] ? (
                                                        <JournalEntry
                                                          journaltext={
                                                            journaltext
                                                          }
                                                          setjournaltext={
                                                            setjournaltext
                                                          }
                                                          journaldate={
                                                            journaldate
                                                          }
                                                          setjournaldate={
                                                            setjournaldate
                                                          }
                                                          addjournalentry={
                                                            addjournalentry
                                                          }
                                                          screenWidth={width}
                                                        />
                                                      ) : (
                                                        <button
                                                          className="btn btn-success"
                                                          onClick={() =>
                                                            openlink(
                                                              "https://seventhsight.com/seventhjournal"
                                                            )
                                                          }
                                                        >
                                                          Learn More
                                                        </button>
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <>
                                                      {bkpinsight?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.[
                                                        "no_journal_entry"
                                                      ] && (
                                                        <JournalEntry
                                                          journaltext={
                                                            journaltext
                                                          }
                                                          setjournaltext={
                                                            setjournaltext
                                                          }
                                                          journaldate={
                                                            journaldate
                                                          }
                                                          setjournaldate={
                                                            setjournaldate
                                                          }
                                                          addjournalentry={
                                                            addjournalentry
                                                          }
                                                          screenWidth={width}
                                                        />
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                              {renderParagraphs(
                                                "Connections",
                                                null,
                                                null,
                                                "Deeper Insights & Connections",
                                                state?.freemium
                                              )}
                                              {renderParagraphs(
                                                "unconscious_echoes",
                                                null,
                                                null,
                                                "Longterm Patterns",
                                                state?.freemium
                                              )}
                                              {renderParagraphs(
                                                "spiritual_religious",
                                                "spiritual_religious_insight",
                                                "relevance_percentage",
                                                "Spiritual & Religious",
                                                state?.freemium
                                              )}
                                              {renderParagraphs(
                                                "love_relationships",
                                                "love_relationships_insight",
                                                "relevance_percentage",
                                                "Love & Relationships",
                                                state?.freemium
                                              )}
                                              {renderParagraphs(
                                                "work_career",
                                                "work_career_insight",
                                                "relevance_percentage",
                                                "Work & Career",
                                                state?.freemium
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  {/* )} */}
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="3">
                              <Row>
                                <Col>
                                  {/* {bkpadvice?.[currentdream["dreamDataId"]]?.[
                                    "loader"
                                  ] ? (
                                    <p className="mt-2 text-danger">
                                      <strong>
                                        Please Wait! We are loading data..
                                      </strong>
                                    </p>
                                  ) : ( */}
                                  {bkpadvice?.[currentdream["dreamDataId"]] && (
                                    <>
                                      {bkpadvice?.[currentdream["dreamDataId"]]
                                        ?.error ? (
                                        <p className="mt-2 text-danger">
                                          <strong>No Data Available</strong>
                                        </p>
                                      ) : (
                                        <>
                                          {Object.keys(
                                            bkpadvice?.[
                                              currentdream["dreamDataId"]
                                            ]
                                          ).length === 0 ? (
                                            <p className="mt-2 text-danger">
                                              <strong>
                                                Please wait, we are analyzing
                                                your results...
                                              </strong>
                                            </p>
                                          ) : (
                                            <div>
                                              <h3 className="mb-2">
                                                Dreamworld Guidance
                                              </h3>
                                              <div
                                                style={
                                                  state?.freemium
                                                    ? { position: "relative" }
                                                    : {}
                                                }
                                              >
                                                {state?.guest &&
                                                  state?.freemium && (
                                                    <FreemiumComponent
                                                      keyobject="DreamWorldGuidance"
                                                      setsignupmodalhome={
                                                        setsignupmodalhome
                                                      }
                                                    />
                                                  )}
                                                {trimvalue(
                                                  bkpadvice?.[
                                                    currentdream["dreamDataId"]
                                                  ]?.["dreamworld_guidance"]
                                                ).map((item, index) => (
                                                  <p
                                                    key={index}
                                                    className="mt-2 capitalfirstword"
                                                  >
                                                    {item}
                                                  </p>
                                                ))}
                                                <h5
                                                  className="mb-4"
                                                  style={{
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  {
                                                    bkpadvice?.[
                                                      currentdream[
                                                        "dreamDataId"
                                                      ]
                                                    ]?.["inspirational_quote"]
                                                  }
                                                </h5>
                                              </div>
                                              <h3 className="mb-2">
                                                Practical Advice
                                              </h3>
                                              <div
                                                style={
                                                  state?.freemium
                                                    ? { position: "relative" }
                                                    : {}
                                                }
                                              >
                                                {state?.guest &&
                                                  state?.freemium && (
                                                    <FreemiumComponent
                                                      keyobject="PracticalAdvice"
                                                      setsignupmodalhome={
                                                        setsignupmodalhome
                                                      }
                                                    />
                                                  )}
                                                {trimvalue(
                                                  bkpadvice?.[
                                                    currentdream["dreamDataId"]
                                                  ]?.["practical_advice"]
                                                ).map((item, index) => (
                                                  <p
                                                    key={index}
                                                    className="mt-2 capitalfirstword"
                                                  >
                                                    {item}
                                                  </p>
                                                ))}
                                              </div>
                                              <h3 className="mt-4 mb-2">
                                                Tailored Tools for
                                                Transformation
                                              </h3>
                                              <div
                                                style={
                                                  state?.freemium
                                                    ? { position: "relative" }
                                                    : {}
                                                }
                                              >
                                                {state?.guest &&
                                                  state?.freemium && (
                                                    <FreemiumComponent
                                                      keyobject="TailoredTools"
                                                      setsignupmodalhome={
                                                        setsignupmodalhome
                                                      }
                                                    />
                                                  )}

                                                {bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"] &&
                                                  bkpadvice?.[
                                                    currentdream["dreamDataId"]
                                                  ]?.["ignite_your_journey"][
                                                    "summary"
                                                  ] && (
                                                    <>
                                                      {trimvalue(
                                                        bkpadvice?.[
                                                          currentdream[
                                                            "dreamDataId"
                                                          ]
                                                        ]?.[
                                                          "ignite_your_journey"
                                                        ]["summary"]
                                                      ).map((item, index) => (
                                                        <p
                                                          key={index}
                                                          className="mt-2 capitalfirstword"
                                                        >
                                                          {item}
                                                        </p>
                                                      ))}
                                                    </>
                                                  )}
                                              </div>
                                              {bkpadvice?.[
                                                currentdream["dreamDataId"]
                                              ]?.["ignite_your_journey"] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "videos"
                                                ] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "videos"
                                                ].length > 0 && (
                                                  <>
                                                    <h3
                                                      className="mt-4"
                                                      style={{
                                                        marginBottom: "0px",
                                                      }}
                                                    >
                                                      Recommended Videos
                                                    </h3>
                                                    <div
                                                      style={
                                                        state?.freemium
                                                          ? {
                                                              position:
                                                                "relative",
                                                            }
                                                          : {}
                                                      }
                                                    >
                                                      {state?.guest &&
                                                        state?.freemium && (
                                                          <FreemiumComponent
                                                            keyobject="RecommendedVideos"
                                                            setsignupmodalhome={
                                                              setsignupmodalhome
                                                            }
                                                          />
                                                        )}
                                                      {bkpadvice?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.[
                                                        "ignite_your_journey"
                                                      ]["videos"].map(
                                                        (item, i) => (
                                                          <div
                                                            key={i}
                                                            className="mt-2"
                                                          >
                                                            <p className="mb-2">
                                                              {item["title"]}
                                                            </p>
                                                            {item["url"] &&
                                                              item["url"].split(
                                                                "="
                                                              ) &&
                                                              item["url"].split(
                                                                "="
                                                              )[1] && (
                                                                <div className="result-video-container mb-2">
                                                                  <iframe
                                                                    width="100%"
                                                                    className="youtube-iframe-new"
                                                                    src={`https://www.youtube.com/embed/${
                                                                      item[
                                                                        "url"
                                                                      ].split(
                                                                        "="
                                                                      )[1]
                                                                    }`}
                                                                  ></iframe>
                                                                </div>
                                                              )}
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                              {bkpadvice?.[
                                                currentdream["dreamDataId"]
                                              ]?.["ignite_your_journey"] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "blogs"
                                                ] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "blogs"
                                                ].length > 0 && (
                                                  <>
                                                    <h3 className="mt-4 mb-2">
                                                      Related Blogs
                                                    </h3>
                                                    <div
                                                      style={
                                                        state?.freemium
                                                          ? {
                                                              position:
                                                                "relative",
                                                            }
                                                          : {}
                                                      }
                                                    >
                                                      {state?.guest &&
                                                        state?.freemium && (
                                                          <FreemiumComponent
                                                            keyobject="RelatedBlogs"
                                                            setsignupmodalhome={
                                                              setsignupmodalhome
                                                            }
                                                          />
                                                        )}

                                                      {bkpadvice?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.[
                                                        "ignite_your_journey"
                                                      ]["blogs"].map(
                                                        (item, i) => (
                                                          <div
                                                            className="d-flex pointer result-podcast-con"
                                                            key={i}
                                                          >
                                                            <img
                                                              className="insightglobe"
                                                              alt="globeicon"
                                                              src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-globe.png"
                                                            />
                                                            <p
                                                              onClick={() =>
                                                                openlink(
                                                                  item["url"]
                                                                )
                                                              }
                                                              className="insightignitep"
                                                            >
                                                              {item["title"]}
                                                            </p>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </>
                                                )}

                                              {bkpadvice?.[
                                                currentdream["dreamDataId"]
                                              ]?.["ignite_your_journey"] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "books"
                                                ] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "books"
                                                ].length > 0 && (
                                                  <>
                                                    <h3 className="mt-4 mb-2">
                                                      Recommended Books
                                                    </h3>
                                                    <div
                                                      style={
                                                        state?.freemium
                                                          ? {
                                                              position:
                                                                "relative",
                                                            }
                                                          : {}
                                                      }
                                                    >
                                                      {state?.guest &&
                                                        state?.freemium && (
                                                          <FreemiumComponent
                                                            keyobject="RecommendedBooks"
                                                            setsignupmodalhome={
                                                              setsignupmodalhome
                                                            }
                                                          />
                                                        )}

                                                      <Row>
                                                        {bkpadvice?.[
                                                          currentdream[
                                                            "dreamDataId"
                                                          ]
                                                        ]?.[
                                                          "ignite_your_journey"
                                                        ]["books"].map(
                                                          (item, i) => (
                                                            <Col
                                                              md={4}
                                                              key={i}
                                                              className="col-4"
                                                              onClick={() =>
                                                                openlink(
                                                                  item["url"]
                                                                )
                                                              }
                                                            >
                                                              <img
                                                                alt="book_img"
                                                                src={
                                                                  item[
                                                                    "image_url"
                                                                  ]
                                                                }
                                                              />
                                                              <p className="insightignitep">
                                                                {item["title"]}
                                                              </p>
                                                            </Col>
                                                          )
                                                        )}
                                                      </Row>
                                                    </div>
                                                  </>
                                                )}
                                              {bkpadvice?.[
                                                currentdream["dreamDataId"]
                                              ]?.["ignite_your_journey"] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "podcast"
                                                ] &&
                                                bkpadvice?.[
                                                  currentdream["dreamDataId"]
                                                ]?.["ignite_your_journey"][
                                                  "podcast"
                                                ].length > 0 && (
                                                  <>
                                                    <h3 className="mt-2 mb-2">
                                                      Recommended Podcasts
                                                    </h3>
                                                    <div
                                                      style={
                                                        state?.guest &&
                                                        state?.freemium
                                                          ? {
                                                              position:
                                                                "relative",
                                                            }
                                                          : {}
                                                      }
                                                    >
                                                      {state?.guest &&
                                                        state?.freemium && (
                                                          <FreemiumComponent
                                                            keyobject="RecommendedPodcasts"
                                                            setsignupmodalhome={
                                                              setsignupmodalhome
                                                            }
                                                          />
                                                        )}
                                                      {bkpadvice?.[
                                                        currentdream[
                                                          "dreamDataId"
                                                        ]
                                                      ]?.[
                                                        "ignite_your_journey"
                                                      ]["podcast"].map(
                                                        (item, i) => (
                                                          <div
                                                            className="d-flex"
                                                            key={i}
                                                          >
                                                            <img
                                                              className="insightglobe"
                                                              alt="globeicon"
                                                              src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-globe.png"
                                                            />
                                                            <p
                                                              onClick={() =>
                                                                openlink(
                                                                  item["url"]
                                                                )
                                                              }
                                                              className="insightignitep"
                                                            >
                                                              {item["title"]}
                                                            </p>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  </>
                                                )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  {/* )} */}
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="4">
                              <Row>
                                <Col>
                                  {bkpdetail?.[currentdream["dreamDataId"]]
                                    ?.loader ? (
                                    <p className="mt-2 text-danger">
                                      <strong>
                                        Please wait, we are analyzing your
                                        results...
                                      </strong>
                                    </p>
                                  ) : (
                                    <>
                                      {bkpdetail?.[
                                        currentdream["dreamDataId"]
                                      ] &&
                                      bkpdetail?.[currentdream["dreamDataId"]]
                                        .length === 0 ? (
                                        <p className="mt-2 text-danger">
                                          <strong>No Data Available</strong>
                                        </p>
                                      ) : (
                                        <div
                                          style={
                                            state?.guest && state?.freemium
                                              ? { position: "relative" }
                                              : {}
                                          }
                                        >
                                          {state?.guest && state?.freemium && (
                                            <FreemiumComponent
                                              keyobject={"Details"}
                                              setsignupmodalhome={
                                                setsignupmodalhome
                                              }
                                            />
                                          )}
                                          <Details
                                            data={
                                              bkpdetail?.[
                                                currentdream["dreamDataId"]
                                              ]
                                            }
                                            handleagree={handleagree}
                                            handledisagree={handledisagree}
                                            guest={state?.guest}
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                          {!loading && (
                            <Nav
                              tabs
                              className="mt-2 mb-5 justify-content-start"
                            >
                              <NavItem className="pointer">
                                <NavLink
                                  className={classnames({
                                    active: currentActiveTab === "1",
                                  })}
                                  onClick={() => toggle("1")}
                                >
                                  Analysis
                                </NavLink>
                              </NavItem>
                              <NavItem className="pointer">
                                <NavLink
                                  className={classnames({
                                    active: currentActiveTab === "2",
                                  })}
                                  onClick={() => {
                                    if (
                                      bkpinsight?.[
                                        currentdream["dreamDataId"]
                                      ] &&
                                      Object.keys(
                                        bkpinsight?.[
                                          currentdream["dreamDataId"]
                                        ]
                                      )?.length != 0
                                    ) {
                                      toggle("2");
                                    }
                                  }}
                                >
                                  {bkpinsight?.[currentdream["dreamDataId"]] &&
                                  Object.keys(
                                    bkpinsight?.[currentdream["dreamDataId"]]
                                  )?.length === 0 ? (
                                    <div className="flexRowStart al-center">
                                      Insights
                                      <div
                                        className="new-spinner"
                                        id="new-spinner"
                                      ></div>
                                    </div>
                                  ) : (
                                    "Insights"
                                  )}
                                </NavLink>
                              </NavItem>
                              <NavItem className="pointer">
                                <NavLink
                                  className={classnames({
                                    active: currentActiveTab === "3",
                                  })}
                                  onClick={() => {
                                    if (
                                      bkpadvice?.[
                                        currentdream["dreamDataId"]
                                      ] &&
                                      Object.keys(
                                        bkpadvice?.[currentdream["dreamDataId"]]
                                      )?.length !== 0
                                    )
                                      toggle("3");
                                  }}
                                >
                                  {bkpadvice?.[currentdream["dreamDataId"]] &&
                                  Object.keys(
                                    bkpadvice?.[currentdream["dreamDataId"]]
                                  )?.length === 0 ? (
                                    <div className="flexRowStart al-center">
                                      Advice
                                      <div
                                        className="new-spinner"
                                        id="new-spinner"
                                      ></div>
                                    </div>
                                  ) : (
                                    "Advice"
                                  )}
                                </NavLink>
                              </NavItem>
                              <NavItem className="pointer">
                                <NavLink
                                  className={classnames({
                                    active: currentActiveTab === "4",
                                  })}
                                  onClick={() => toggle("4")}
                                >
                                  Details
                                </NavLink>
                              </NavItem>
                            </Nav>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Footer */}
      <FooterSeventhJournal
        footeremail={footeremail}
        footernum={footernum}
        toggleMenu={toggleMenu}
      />
      <Modal isOpen={feedbackmodal} toggle={togglefeedback}>
        <ModalHeader toggle={togglefeedback}>Feedback</ModalHeader>
        <ModalBody>
          <div>
            <Form onSubmit={handleSubmit}>
              <FormGroup className="position-relative">
                <Label>Email</Label>
                <Input
                  // placeholder="Email Address"
                  type="email"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="position-relative">
                <Label>User Name</Label>
                <Input
                  // placeholder="Username"
                  value={username}
                  onChange={(e) => setusername(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="position-relative">
                <Label>Review</Label>
                <Input
                  // placeholder="Review"
                  type="textarea"
                  className="textarea-lg"
                  value={review}
                  onChange={(e) => setreview(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="position-relative">
                {args.captchaKey && (
                  <>
                    <Label>Captcha</Label>
                    <ReCAPTCHA
                      name="recaptcha"
                      sitekey={args.captchaKey}
                      render="explicit"
                      theme="dark"
                      onChange={(e) => {
                        // console.log(e);
                        setCaptchaValidity(e);
                      }}
                    />
                  </>
                )}
              </FormGroup>
              <Button className="w-100 btn-primary mt-4">Submit</Button>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Result;
